// Propósito: cálculo puro de la posición del submenu flotante.
export interface FloatPos {
  top: string;
  bottom: string;
  arrowTop: string;
  arrowBottom: string;
  lineTop: string;
  lineBottom: string;
}

// Indica si el submenu cabe debajo.
export function fitsBelow(windowHeight: number, targetTop: number, targetHeight: number): boolean {
  return (windowHeight - targetTop) > targetHeight;
}

// Calcula la posición izquierda.
export function floatLeft(offsetWidth: number, sidebarLeft: number): string {
  return (offsetWidth + sidebarLeft) + 'px';
}

// Posición cuando cabe debajo.
export function topPos(offsetTop: number): FloatPos {
  return {
    top: offsetTop + 'px',
    bottom: 'auto',
    arrowTop: '20px',
    arrowBottom: 'auto',
    lineTop: '20px',
    lineBottom: 'auto'
  };
}

// Posición cuando va abajo.
export function bottomPos(windowHeight: number, targetTop: number): FloatPos {
  const arrow = arrowBottom(windowHeight, targetTop);
  return {
    top: 'auto',
    bottom: '0',
    arrowTop: 'auto',
    arrowBottom: arrow,
    lineTop: '20px',
    lineBottom: arrow
  };
}

// Calcula el borde inferior de la flecha.
export function arrowBottom(windowHeight: number, targetTop: number): string {
  return ((windowHeight - targetTop) - 21) + 'px';
}

// Elige la posición según el espacio.
export function calcFloatPos(windowHeight: number, targetTop: number, targetHeight: number, offsetTop: number): FloatPos {
  if (fitsBelow(windowHeight, targetTop, targetHeight)) return topPos(offsetTop);
  return bottomPos(windowHeight, targetTop)
}
